import React, { useState, useEffect } from "react";

function Property_Images({  
  setFee, 
  setAgreementq, 
  setUploadagreenment, 
  setPortal, 
  setDocquiz, 
  setFrontid, 
  setBackid, 
  setPropertyimages,
  uniq
}) {
          const [selectedImage, setSelectedImage] = useState();
          const [next, setNext] = useState(false)
          const [loading, setLoading] = useState(false)
      
          const handleSubmit = async (event) => {
            event.preventDefault();
      
            setLoading(true)
            setNext(false)
        
            const fileInput = document.getElementById('file-upload');
            const file = fileInput.files[0];
        
            if (!file) return;
        
            const formData = new FormData();
            formData.append('image', file);
            formData.append('unik', uniq);
        
            setLoading(true); // Show loading spinner
        
            try {
              const response = await fetch('https://hosteladventures.site/PHP/Pic_php/Upload_property_image.php', {
                method: 'POST',
                body: formData,
              });
        
              const result = await response.json();
              console.log(result);
      
              if(result.message=='Image uploaded successfully')
              {
                //setFee(true)
                //setPropertyimages(false)
                alert('COGRATULATIONS!! All good!!')
              }
              // Hide the loading spinner once the response is received
              setLoading(false);
        
              // Handle the response from the server (e.g., display a success message)
            } catch (error) {
              console.error('Error uploading image:', error);
              setLoading(false); // Hide spinner in case of error
            }
          };
      
      
          const handleImageChange = (event) => {
              const file = event.target.files[0];
              if (file) {
                const imageUrl = URL.createObjectURL(file);
                setSelectedImage(imageUrl);
                setNext(true)
              }
            };
        return (
          <div className='property_doc_Inner'>
          <form className='docs' onSubmit={handleSubmit} >
      
              <div className='img_Disp'><img src={selectedImage} /></div>
      
              <div className='label_DIV'><label className='img_label' htmlFor="file-upload">Click to choose Property Images</label></div>
              <input className='choose_img' accept="image/jpeg, image/jpg"  id="file-upload"  type='file' onChange={handleImageChange} />
      
              {next?(<button type='submit'className='submit'>Next</button>):('')}
              {loading?(<button className='submit'>Loading</button>):('')}
              
      
          </form>
      </div>
        )
}

export default Property_Images